import { render, staticRenderFns } from "./baseIm.vue?vue&type=template&id=5baa0d96&"
import script from "./baseIm.vue?vue&type=script&lang=js&"
export * from "./baseIm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports